import { combineReducers } from 'redux';
import { isAfter, isBefore } from 'date-fns';

const defaultAnalytics = [];
const analyticsList = (state = defaultAnalytics, action) => {
  switch (action.type) {
    case 'GET_ANALYTICS_SUCCESS':
      return [...action.analytics];
    default:
      return state;
  }
}

const defaultAnalyticsFilter = [];
const analyticsListFilter = (state = defaultAnalyticsFilter, action) => {
  switch (action.type) {
    case 'GET_ANALYTICS_FILTER_SUCCESS':
      const analyticsList = action.analyticsList
      const callsReport = analyticsList.reduce((acc, item) => {
        return item.callsReport ? acc.concat(item.callsReport) : acc
      }, []).sort((a, b) => {
        const one = new Date(a.time);
        const two = new Date(b.time);
        return one > two ? 1 : one < two ? -1 : 0;
      });

      const callsReportFilter = callsReport.filter((item) => {
        let startDate = action.customRange[1];
        let endDate = action.customRange[0];
        if (isAfter(new Date(item.time), new Date(startDate))) {
          return isBefore(new Date(item.time), new Date(endDate));
        };
      });
       return callsReportFilter;
    default:
      return state;
  }
}

export default combineReducers({
  analyticsList,
  analyticsListFilter
});
